module.exports = __webpack_public_path__ + "static/media/data.d8a6f7d5.jpg";